export const NAMESPACE = 'webdriver-commands';
export const TIME_TYPE = Object.freeze({
  TIMELINE: 'TIMELINE',
  STARTTIME: 'STARTTIME',
});
